module.exports = __webpack_public_path__ + "img/the-woman-with-a-worm-in-her-head-and-other-true-stories-of-infectious-disease.397bb3f9.png";